import axios from "../axios-auth";
import orginal_axios from "axios";

export const assetDetailReportService = {
    getAssetDetailReportList,
    exportAllAssetDetailReportExcel,
};

function getAssetDetailReportList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.branchId) {
        params["branchId"] = searchParams.branchId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.assetName) {
        params["assetName"] = searchParams.assetName;
    }
    if (searchParams.assetType) {
        params["assetType"] = searchParams.assetType;
    }

    return axios.get("/auth/asset-detail-reports", { params });
}

function exportAllAssetDetailReportExcel(searchParams) {
    let params = {};

    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.branchId) {
        params["branchId"] = searchParams.branchId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.assetName) {
        params["assetName"] = searchParams.assetName;
    }
    if (searchParams.assetType) {
        params["assetType"] = searchParams.assetType;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/export-all-asset-detail-reports",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}